
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface JobEmploymentTypeFieldProps {
  job: Pick<Job, 'employment_type'>; // Removed 'type'
  isEditing: boolean;
  formDataEmploymentType: Job['employment_type'];
  onSelectChange: (name: 'employment_type', value: string) => void;
}

const employmentTypeOptions: Exclude<Job['employment_type'], undefined | null>[] = ["Full-time", "Part-time", "Contract", "Temporary", "Internship"];

export const JobEmploymentTypeField: React.FC<JobEmploymentTypeFieldProps> = ({ job, isEditing, formDataEmploymentType, onSelectChange }) => {
  return (
    <div>
      <Label className="text-xs font-medium text-muted-foreground">Job Type</Label>
      {isEditing ? (
        <Select
          value={formDataEmploymentType || ''}
          onValueChange={(value) => onSelectChange('employment_type', value)}
        >
          <SelectTrigger className="text-sm">
            <SelectValue placeholder="Select employment type" />
          </SelectTrigger>
          <SelectContent>
            {employmentTypeOptions.map(option => (
              option && <SelectItem key={option} value={option}>{option}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        // Updated to use only employment_type
        <p>{job.employment_type || 'N/A'}</p>
      )}
    </div>
  );
};
